import PartnerAuthenticator from 'aa/vue/components/partner/PartnerAuthenticator';
import { TN_SIGNIN_DEFAULT_ENABLED } from 'aa/helpers/featureConstants';
import Step from 'models/steps/Step';
import PartnerService from 'services/PartnerService';

const createAccountCallback = (componentRef) => {
    componentRef.$router.push({
        name: 'SIGNUP',
        params: { fromPartnerConfirmation: true },
    });
};
const bindAccountCallback = (componentRef) => {
    // TN sign-in reads the PartnerService sessionStorage contract
    // (which survives this same-origin navigation) and runs bindWithPartner
    // after auth, so hand the guest to TN instead of the legacy SIGNIN step.
    // Keep the region prefix (e.g. /gb) or TN's regional-redirects middleware
    // bounces INTL guests back to the legacy signin.
    if (componentRef.$store.getters.featureIsActive(TN_SIGNIN_DEFAULT_ENABLED)) {
        const regionBaseUrl = componentRef.$root.serverData.regionBaseUrl || '';
        window.location.href = `${regionBaseUrl}/account/signin/`;
        return;
    }
    componentRef.$router.push({
        name: 'SIGNIN',
        params: { fromPartnerConfirmation: true },
    });
};

export default class Partner extends Step {
    path = '/partner-auth/:partner';
    name = 'PartnerAuthenticator';
    pathToRegexpOptions = { strict: true };
    component = PartnerAuthenticator;
    props = {
        isValidRedirect: true,
        createAccountCallback: createAccountCallback,
        bindAccountCallback: bindAccountCallback,
    };

    // TODO: Get partner flow name from url csp value / page attribtues
    async beforeEnter(to, from, next) {
        const { params } = to;
        const partnerCSPValue = params?.partner;
        this._store.commit('partner/setPartnerCSPValue', partnerCSPValue);
        PartnerService.setPartnerFlow(partnerCSPValue);

        const isEmpty = (obj) =>
            [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;

        this.props.isValidRedirect = !isEmpty(to.query);
        this.enterRoute(to, from, next);
    }

    getTrackingArgs(to) {
        const args = {
            ...super.getTrackingArgs(),
            pageType: 'partner_entry',
        };

        return args;
    }
}
